import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import ImageIcon from "@mui/icons-material/Image";
import WorkIcon from "@mui/icons-material/Work";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import axios from "axios";
import Swal from "sweetalert2";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const ModalSec = ({ open, close,assignId, deliveryBoyList ,fetchData}) => {
const asignDeliveryBoy = async (driverId, driverName) => {
   await close();  
  const confirm = await Swal.fire({
    title: "Confirm Assignment",
    text: `Do you want to assign this order to ${driverName}?`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes, Assign",
    cancelButtonText: "No",
  });

  if (!confirm.isConfirmed) return;

  try {
    const res = await axios.post(
      "https://thekrish.in/api/cryptographyapi/ChangeOrderStatusnew",
      {
        OrderId: assignId, // 👈 jo order assign karna hai
        OrderStatus: "Assigned",
        DeliveryBoyId: driverId,
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    if (res.data.Status === 1) {
      Swal.fire(
        "Assigned!",
        `Order assigned to ${driverName}`,
        "success"
      );
         // modal close
      fetchData();   // order refresh
    } else {
      Swal.fire("Failed", "Assignment failed", "error");
    }
  } catch (error) {
    Swal.fire("Error", "Something went wrong!", "error");
  }
};

  return (
    <div>
     <Modal
  open={open}
  onClose={close}
  aria-labelledby="modal-modal-title"
>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 380,
      bgcolor: "background.paper",
      borderRadius: 2,
      boxShadow: 24,
      p: 2,
    }}
  >
    <Typography
      id="modal-modal-title"
      variant="h6"
      sx={{ mb: 2, fontWeight: 600 }}
      className="css-1mzrxvy-MuiTypography-root"
    >
      Select Delivery Boy
    </Typography>

    <List
      sx={{
        maxHeight: 300,
        overflowY: "auto",
      }}
    >
      {deliveryBoyList.length ? (
        deliveryBoyList.map((item, i) => (
          <ListItem
            key={i}
            divider
            secondaryAction={
              <Button
                size="small"
                variant="contained"
                color="primary"
                onClick={() => asignDeliveryBoy(item.Id,item?.UserName)}
              >
                Assign 
              </Button>
            }
          >
            <ListItemText
              primary={
                <Typography fontWeight={500}>
                  {item.UserName}
                </Typography>
              }
              secondary={item.MobileNo}
            />
          </ListItem>
        ))
      ) : (
        <Typography textAlign="center" color="text.secondary">
          No delivery boys available
        </Typography>
      )}
    </List>

    <Box textAlign="right" mt={2}>
      <Button onClick={close} color="inherit">
        Close
      </Button>
    </Box>
  </Box>
</Modal>

    </div>
  );
};
export default ModalSec;
